import { Edge, Node } from 'reactflow';

const SENSITIVE_KEYS = /api[_-]?key|token|secret|password|authorization|credential/i;

function scrubValue(value: any, depth = 0): any {
  if (depth > 6 || value == null) return value;
  if (typeof value === 'string') {
    if (value.length > 1200) return `${value.slice(0, 1200)}…`;
    return value;
  }
  if (Array.isArray(value)) return value.slice(0, 40).map((v) => scrubValue(v, depth + 1));
  if (typeof value === 'object') {
    const out: Record<string, any> = {};
    for (const [k, v] of Object.entries(value)) {
      if (SENSITIVE_KEYS.test(k)) {
        out[k] = typeof v === 'string' && v ? '[REDACTED]' : null;
        continue;
      }
      // Drop nested connection secrets; keep only connection id/name if present
      if (k === 'connection' && v && typeof v === 'object') {
        out[k] = {
          id: (v as any).id || (v as any)._id || undefined,
          name: (v as any).name || (v as any).label || undefined,
          hasCredentials: true,
        };
        continue;
      }
      out[k] = scrubValue(v, depth + 1);
    }
    return out;
  }
  return value;
}

/** Compact, privacy-safe workflow snapshot for LLM context. */
export function serializeWorkflowForAi(nodes: Node[], edges: Edge[]) {
  return {
    nodeCount: nodes.length,
    edgeCount: edges.length,
    nodes: nodes.map((n) => ({
      id: n.id,
      action: n.data?.action,
      name: n.data?.name,
      index: n.data?.index,
      position: n.position,
      handles: n.data?.postions || n.data?.positions,
      value: scrubValue(n.data?.value),
    })),
    edges: edges.map((e) => ({
      id: e.id,
      source: e.source,
      target: e.target,
      sourceHandle: e.sourceHandle,
      targetHandle: e.targetHandle,
    })),
  };
}
